import flatten from "ramda/src/flatten"
import map from "ramda/src/map"
import filter from "ramda/src/filter"
import where from "ramda/src/where"
import equals from "ramda/src/equals"
import startsWith from "ramda/src/startsWith"
import mergeDeepRight from "ramda/src/mergeDeepRight"
import contains from "ramda/src/contains"
import _get from "lodash/get"
import _filter from "lodash/filter"
import _isEmpty from "lodash/isEmpty"
import _includes from "lodash/includes"
import _deburr from "lodash/deburr"
import _set from "lodash/set"
import _find from "lodash/find"
import _map from "lodash/map"
import _findIndex from "lodash/findIndex"
import * as ActionTypes from "services/state/action-types"
import { isExpiredDate } from "services/utils/date"
import { getCookie } from "services/utils/cookie"
import { deBase64 } from "services/utils/generateBase64"
import {
  OPEN,
  DUE,
  NEXT,
  CLOSED,
  ProductsValidMpe,
  ProductsTNCM,
  SIN,
  ACTIVE,
  ENABLED_INCIDENT_PRODUCT_SYSTEMS,
  TELEFONIA_MOVEL,
  COMUNICACAO_DADOS,
  BANDA_LARGA
} from "./constants"
import { groupByProductLine } from "./adapter"

const BILL_SET_ALIAS_INITIAL_STATE = {
  isOpenSuccess: false,
  isOpenError: false,
  isOpen: false
}

export function billSetAlias(state = BILL_SET_ALIAS_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.SET_ACCOUNT_ALIAS_NAME:
      return { ...state, loading: true, isOpen: false }

    case ActionTypes.SET_ACCOUNT_ALIAS_NAME_SUCCESS:
      return { ...state, isOpenSuccess: true, loading: false }

    case ActionTypes.SET_ACCOUNT_ALIAS_NAME_CLOSE_SUCCESS:
      return { ...state, isOpenSuccess: false, loading: false }

    default:
      return state
  }
}

const BILLS_INITIAL_STATE = {
  loading: false,
  error: false,
  selected: null,
  data: null,
  email: ""
}

export function bills(state = BILLS_INITIAL_STATE, action) {
  let billsWithAlias, response
  switch (action.type) {
    case ActionTypes.GET_BILLS:
      return { ...state, loading: true }

    case ActionTypes.GET_BILLS_FAIL:
      return { ...state, error: true, loading: false }

    case ActionTypes.GET_BILLS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: false
      }

    case ActionTypes.SELECT_BILL:
      if (!_get(action, "payload.aliasName")) {
        return { ...state, selected: { ...action.payload, aliasName: "" } }
      }

      return { ...state, selected: action.payload }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...BILLS_INITIAL_STATE }

    case ActionTypes.FIND_EMAIL_BILLING_ACCOUNT:
      return { ...state, loading: false }

    case ActionTypes.FIND_EMAIL_BILLING_ACCOUNT_FAIL:
      return { ...state, loading: false }

    case ActionTypes.FIND_EMAIL_BILLING_ACCOUNT_SUCCESS:
      if (state.selected !== null) {
        return {
          ...state,
          loading: false,
          selected: { ...state.selected, email: action.payload.email }
        }
      }

      return { ...state }

    case ActionTypes.GET_ACCOUNT_ALIAS_NAME:
      return { ...state, loading: true }

    case ActionTypes.GET_ACCOUNT_ALIAS_NAME_SUCCESS:
      billsWithAlias =
        billsAliasNameMount(state, action.payload.data.resultData) || {}

      return {
        ...state,
        errors: false,
        loading: false,
        ...billsWithAlias
      }

    case ActionTypes.GET_ACCOUNT_ALIAS_NAME_FAIL:
      response = _get(action, "error.response")

      if (_get(response, "status") === 404) {
        return {
          ...state,
          loading: false,
          selected: { ...state.selected, alias: "" }
        }
      }

      return {
        ...state,
        errors: true,
        loading: false,
        selected: { ...state.selected, alias: "" }
      }

    case ActionTypes.DELETE_ACCOUNT_ALIAS_NAME:
      return { ...state, loading: true }

    case ActionTypes.DELETE_ACCOUNT_ALIAS_NAME_FAIL:
      return { ...state, loading: false, errors: true }

    case ActionTypes.DELETE_ACCOUNT_ALIAS_NAME_SUCCESS:
      return { ...state, loading: false, errors: false }

    default:
      return state
  }
}

const INVOICES_INITIAL_STATE = {
  loading: false,
  downloading: false,
  download: { async: false },
  error: false,
  data: [],
  [OPEN]: { data: [] },
  [DUE]: { data: [] },
  [NEXT]: { data: [] },
  [CLOSED]: { data: [] },
  errorDownload: false,
  resultDownload: null
}

export function invoices(state = INVOICES_INITIAL_STATE, action) {
  const reduceHandler = reduceBuilder(action, state)

  switch (action.type) {
    case ActionTypes.GET_INVOICES:
      return { ...state, loading: true }

    case ActionTypes.DOWNLOAD_INVOICE:
    case ActionTypes.SEND_INVOICE_BY_EMAIL:
    case ActionTypes.GET_INVOICE_PIX:
    case ActionTypes.GET_INVOICE_BARCODE:
    case ActionTypes.DOWNLOAD_INVOICE_LARGE:
    case ActionTypes.DOWNLOAD_HUGE_INVOICE:
    case ActionTypes.DOWNLOAD_MULTIPLE_INVOICES:
      return { ...state, downloading: true, errorDownload: false }
    case ActionTypes.GET_INVOICE_BARCODE_SUCCESS:
      return {
        ...state,
        downloading: false,
        errorDownload: false,
        resultData: action.payload
      }
    case ActionTypes.GET_INVOICE_BARCODE_ERROR:
    case ActionTypes.GET_INVOICE_PIX_SUCCESS:
    case ActionTypes.GET_INVOICE_PIX_ERROR:
      return {
        ...state,
        downloading: false,
        errorDownload: false
      }
    case ActionTypes.DOWNLOAD_INVOICE_LARGE_FAIL:
      return {
        ...state,
        downloading: false,
        errorDownload: true
      }

    case ActionTypes.DOWNLOAD_INVOICE_SUCCESS:
    case ActionTypes.SEND_INVOICE_BY_EMAIL_SUCCESS:
    case ActionTypes.DOWNLOAD_HUGE_INVOICE_SUCCESS:
    case ActionTypes.DOWNLOAD_MULTIPLE_INVOICES_SUCCESS:
      return {
        ...state,
        downloading: false,
        errorDownload: false,
        resultDownload: action.payload || {
          blob: null,
          fileName: null,
          failedInvoices: []
        }
      }

    case ActionTypes.DOWNLOAD_MULTIPLE_INVOICES_RESET:
      return {
        ...state,
        errorDownload: false,
        resultDownload: null
      }

    case ActionTypes.DOWNLOAD_INVOICE_LARGE_SUCCESS:
      return {
        ...state,
        downloading: false,
        errorDownload: false,
        resultDownload: action.payload.data,
        download: { async: true }
      }

    case ActionTypes.DOWNLOAD_INVOICE_FAIL:
    case ActionTypes.SEND_INVOICE_BY_EMAIL_FAIL:
    case ActionTypes.DOWNLOAD_HUGE_INVOICE_FAIL:
    case ActionTypes.DOWNLOAD_MULTIPLE_INVOICES_FAIL:
      return { ...state, downloading: false, errorDownload: true }

    case ActionTypes.GET_ALL_INVOICES_FAIL:
      return { ...state, data: action.payload, loading: false, error: true }

    case ActionTypes.GET_ALL_INVOICES_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: false }

    case ActionTypes.GET_INVOICES_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.GET_INVOICES_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: false
      }

    case ActionTypes.FILTER_OPEN_INVOICES:
      return reduceHandler(OPEN, openInvoicesCriteria)

    case ActionTypes.FILTER_DUE_INVOICES:
      return reduceHandler(DUE, dueInvoicesCriteria)

    case ActionTypes.FILTER_NEXT_INVOICES:
      return reduceHandler(NEXT, nextInvoicesCriteria)

    case ActionTypes.FILTER_CLOSED_INVOICES:
      return reduceHandler(CLOSED, closedInvoicesCriteria)

    case ActionTypes.FILTER_CLOSED_INVOICES_SUCCESS:
      return { ...state, loading: false, error: false }

    case ActionTypes.INVOICE_ASYNC_DOWNLOAD_NOTIFICATION:
      return { ...state, download: { async: true } }

    case ActionTypes.INVOICE_ASYNC_DOWNLOAD_NOTIFICATION_DISMISS:
      return { ...state, download: { async: false } }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...INVOICES_INITIAL_STATE }

    default:
      return state
  }
}

function billsAliasNameMount(bills, nameAliases) {
  let selectedBill = _get(bills, "selected")
  const billsData = _get(bills, "data")
  const billsWithAlias = {}

  billsWithAlias.data = _map(billsData, (bill) => {
    bill.aliasName = _get(
      _find(nameAliases, { billAccount: bill.accountNumber }) || {},
      "alias",
      ""
    )
    return bill
  })

  selectedBill = selectedBill
    ? {
        ...selectedBill,
        aliasName: _get(
          _find(nameAliases, {
            billAccount:
              selectedBill.accountNumber || selectedBill.billingAccountNumber
          }) || {},
          "alias",
          ""
        )
      }
    : null

  _set(billsWithAlias, "selected", selectedBill)

  return billsWithAlias
}

function openInvoicesCriteria(term) {
  return {
    status: equals(OPEN),
    id: startsWith(term)
  }
}

function dueInvoicesCriteria(term) {
  return {
    status: equals(OPEN),
    id: startsWith(term),
    dueDate: (v) => isExpiredDate(v)
  }
}

function nextInvoicesCriteria(term) {
  return {
    status: equals(OPEN),
    id: startsWith(term),
    dueDate: (v) => !isExpiredDate(v)
  }
}

function closedInvoicesCriteria(term) {
  return {
    status: equals(CLOSED),
    id: startsWith(term)
  }
}

function reduceBuilder({ payload }, state) {
  if (!payload) return null

  const { term } = payload

  return (name, criteria) => {
    const compiledCriteria = criteria(term)
    const handler = filter(where(compiledCriteria))
    const data = handler(state.data)

    return { ...state, [name]: { data, term } }
  }
}

const PRODUCTS_INITIAL_STATE = {
  loading: false,
  error: false,
  selected: null,
  data: [],
  productsTNCM: [],
  productsValidMpe: [],
  isMpe: false,
  download: { async: false },
  downloading: false,
  detail: {
    loading: false,
    data: null,
    error: false
  },
  plant: { data: null },
  repair: { data: null },
  continueCancel: true,
  hasNextPage: false,
  lastPageWithProductsCRM: 0,
  menuOpen: [],
  svaToken: "",
  blockedProducts: null,
  assetDetails: {},
  errorDetails: false
}

export function products(state = PRODUCTS_INITIAL_STATE, action) {
  let plant, detail, data, repair
  let hasNextPage,
    lastPageWithProductsCRM,
    menuOpen,
    resultAssets,
    hasResultAssets
  let documentNumber, customer, isMpe, productsValidMpe, productsTNCM
  let params, productId, productIdIndex, newProduct, newPlantData, newPlant
  let token, details, errorDetails

  switch (action.type) {
    case ActionTypes.GET_PRODUCTS:
      if (action.meta && action.meta.silent) {
        return { ...state }
      }

      return { ...state, loading: true }

    case ActionTypes.GET_PRODUCTS_SUCCESS:
      hasNextPage = _get(action, "payload.data.hasNextPage", false)
      lastPageWithProductsCRM = _get(
        action,
        "payload.data.lastPageWithProductsCRM",
        0
      )
      menuOpen = []

      resultAssets = _get(action, "payload.data.resultAssets", [])
      hasResultAssets = resultAssets.length

      data = hasResultAssets ? resultAssets : _get(action, "payload.data", [])

      documentNumber = deBase64(getCookie("customerKey"))
      customer = JSON.parse(window.localStorage.getItem("customerData"))
      isMpe = _get(customer, "customerSegment", "") === "BUSINESS"
      data = groupByProductLine(data, documentNumber)

      if (isMpe) {
        productsValidMpe = _filter(resultAssets, (item) => {
          const productName = _deburr(
            _get(item, "product.name", "")
          ).toLowerCase()
          const productFullName = _deburr(
            _get(item, "assetFullName", "")
          ).toLowerCase()
          return (
            _includes(ProductsValidMpe, productName) ||
            ProductsValidMpe.some((p) => productFullName.includes(p)) ||
            isAllowedToOpenSupportForCellphoneProduct(item) ||
            isAllowedToOpenSupportForInternetProduct(item)
          )
        })
      }

      productsTNCM = _filter(resultAssets, (item) => {
        const productName = _deburr(
          _get(item, "product.name", "")
        ).toLowerCase()
        const productFullName = _deburr(
          _get(item, "assetFullName", "")
        ).toLowerCase()

        return (
          _includes(ProductsTNCM, productName) ||
          ProductsTNCM.some((p) => productFullName.includes(p)) ||
          isAllowedToOpenSupportForCellphoneProduct(item) ||
          isAllowedToOpenSupportForInternetProduct(item)
        )
      })

      plant = { data: mapProductsPlant(data) }
      repair = { data: filter(isAllowedIncidentProduct, plant.data) }

      plant.data.map((item) => {
        return menuOpen.push({ id: item.agreementId, isOpen: false })
      })

      return {
        ...state,
        data,
        plant,
        repair,
        hasNextPage,
        loading: false,
        menuOpen,
        productsTNCM,
        productsValidMpe,
        isMpe,
        lastPageWithProductsCRM
      }

    case ActionTypes.GET_PRODUCTS_FAIL:
      return { ...state, loading: false, error: false }

    case ActionTypes.SELECT_PRODUCT:
      return { ...state, selected: action.payload }

    case ActionTypes.GET_PRODUCT_DETAIL:
      detail = { loading: true, error: false }
      return { ...state, detail }

    case ActionTypes.GET_PRODUCT_DETAIL_SUCCESS:
      data = { ...state.selected, ...action.payload.data }
      detail = { data, loading: false, error: false }

      return mergeDeepRight(state, { detail })

    case ActionTypes.GET_PRODUCT_DETAIL_FAIL:
      detail = { loading: false, error: true }
      return mergeDeepRight(state, { detail })

    case ActionTypes.SEND_PRODUCTS_PLANT_BY_EMAIL:
      return mergeDeepRight(state, {
        downloading: true,
        download: { async: false }
      })

    case ActionTypes.SEND_PRODUCTS_PLANT_BY_EMAIL_SUCCESS:
      return mergeDeepRight(state, {
        downloading: false,
        download: { async: true }
      })

    case ActionTypes.SEND_PRODUCTS_PLANT_BY_EMAIL_FAIL:
      return mergeDeepRight(state, {
        downloading: false,
        download: { async: false }
      })

    case ActionTypes.SEND_PRODUCTS_PLANT_BY_EMAIL_DISMISS:
      return mergeDeepRight(state, {
        download: { async: false, error: false }
      })

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...PRODUCTS_INITIAL_STATE }

    case ActionTypes.CAN_CANCEL:
      return { ...state, continueCancel: true }

    case ActionTypes.CAN_CANCEL_SUCCESS:
      return { ...state, continueCancel: true }

    case ActionTypes.CAN_CANCEL_FAIL:
      return { ...state, continueCancel: false }

    case ActionTypes.CANCEL_SUBSCRIPTION:
      return { ...state, continueCancel: true }

    case ActionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
      params = JSON.parse(action.payload.config.data)
      productId = _get(params, "productId", "")
      productIdIndex = _findIndex(state.plant.data, { productId })
      newProduct = { ...state.plant.data[productIdIndex] }

      newProduct.productStatus = "FINISHED"

      newPlantData = [
        ...state.plant.data.slice(0, productIdIndex),
        newProduct,
        ...state.plant.data.slice(productIdIndex + 1)
      ]

      newPlant = { data: newPlantData }

      return {
        ...state,
        plant: newPlant,
        protocol: action.payload.data.protocoloUnico,
        plantUpdated: true
      }

    case ActionTypes.CANCEL_SUBSCRIPTION_FAIL:
      return { ...state, continueCancel: false }

    case ActionTypes.PLANT_UPDATED_SUCCESS:
      return { ...state, plantUpdated: false }

    case ActionTypes.GENERATE_SVA_TOKEN:
      return { ...state, loading: true }

    case ActionTypes.GENERATE_SVA_TOKEN_SUCCESS:
      token = _get(action, ["payload", "data", "access_token"])
      return { ...state, loading: false, svaToken: token }

    case ActionTypes.GENERATE_SVA_TOKEN_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.GET_BLOCKED_PRODUCTS:
      return { ...state }

    case ActionTypes.GET_BLOCKED_PRODUCTS_SUCCESS:
      return { ...state, blockedProducts: action.payload }

    case ActionTypes.GET_ASSET_DETAILS:
      return { ...state, loading: true }

    case ActionTypes.GET_ASSET_DETAILS_SUCCESS:
      details = _get(action, "payload.data", null)
      errorDetails = _isEmpty(details)

      return { ...state, loading: false, assetDetails: details, errorDetails }

    case ActionTypes.GET_ASSET_DETAILS_FAIL:
      return { ...state, loading: false, errorDetails: true }

    default:
      return state
  }
}

function mapProductsPlant(data) {
  if (!data) return

  if (data.status === "200") return null

  return flatten(
    map(
      ({ products, lineOfBusiness }) =>
        map((product) => ({ ...product, lineOfBusiness }), products),
      data
    )
  )
}

function isAllowedToOpenSupportForCellphoneProduct(product) {
  const productLineName = _get(
    product,
    "productLine.name",
    _get(product, "lineOfBusiness", "")
  ).toUpperCase()

  return (
    productLineName === COMUNICACAO_DADOS || productLineName === BANDA_LARGA
  )
}

function isAllowedToOpenSupportForInternetProduct(product) {
  const productLineName = _get(
    product,
    "productLine.name",
    _get(product, "lineOfBusiness", "")
  ).toUpperCase()

  return productLineName === TELEFONIA_MOVEL
}

function isAllowedIncidentProduct({
  lineOfBusiness,
  productSystem,
  productStatus
}) {
  return (
    !contains(lineOfBusiness, ["TV", "PACOTE", "TELEFONIA MOVEL"]) &&
    productSystem !== SIN &&
    productStatus === ACTIVE &&
    _includes(ENABLED_INCIDENT_PRODUCT_SYSTEMS, productSystem)
  )
}

const FEBRABAN_INITIAL_STATE = {
  loading: false,
  data: []
}

export function febraban(state = FEBRABAN_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_FEBRABAN_ACCOUNTS:
      return { ...state, loading: true }

    case ActionTypes.GET_FEBRABAN_ACCOUNTS_SUCCESS:
      return {
        ...state,
        data: action.payload.data.invoiceFebrabanList,
        loading: false
      }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...FEBRABAN_INITIAL_STATE }

    case ActionTypes.CLEAR_FEBRABAN:
      return { ...FEBRABAN_INITIAL_STATE }

    default:
      return state
  }
}

const MONTHS_DETAILING_INITIAL_STATE = {
  data: null,
  loader: false,
  sendEmails: false,
  errorSendEmails: false,
  error: false,
  downloadSucess: false
}

export function monthsDetailing(
  state = MONTHS_DETAILING_INITIAL_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.MONTHS_LOADER:
      return { ...state, loader: action.payload }

    case ActionTypes.MONTHS_DETAILING:
      return { ...state, data: action.payload, loader: false }

    case ActionTypes.MONTHS_DETAILING_DOWNLOAD_SUCCESS:
      return { ...state, downloadSucess: true, error: false }

    case ActionTypes.MONTHS_DETAILING_DOWNLOAD_FAIL:
      return { ...state, loader: false, error: true }

    case ActionTypes.MONTHS_DETAILING_EMAILS_SUCCESS:
      return { ...state, loader: false, sendEmails: true }

    case ActionTypes.MONTHS_DETAILING_EMAILS_FAIL:
      return { ...state, loader: false, errorSendEmails: true }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...MONTHS_DETAILING_INITIAL_STATE }

    case ActionTypes.GET_PRODUCTS:
      return { ...state, loader: true }

    case ActionTypes.GET_PRODUCTS_SUCCESS:
      return { ...state, loader: false }

    case ActionTypes.GET_PRODUCTS_FAIL:
      return { ...state, loader: false }

    case ActionTypes.SET_ERROR_DOWNLOAD:
      return { ...state, error: false }

    default:
      return state
  }
}

const UPDATE_PRODUCTS_INITIAL_STATE = {
  result: null,
  dates: null,
  resultMsg: null,
  type: null,
  loading: false
}

export function updateProducts(state = UPDATE_PRODUCTS_INITIAL_STATE, action) {
  let dates,
    returnData,
    messageKey,
    protocol,
    protocolNumberData,
    protocolNumberAlreadyExists,
    resultMessage

  switch (action.type) {
    case ActionTypes.UPDATE_PRODUCTS_DETAILS:
      return { ...state, result: action.payload, loading: true }

    case ActionTypes.UPDATE_PRODUCTS_DETAILS_SUCCESS:
      return {
        ...state,
        result: action.payload.data,
        loading: false,
        type: "success"
      }

    case ActionTypes.UPDATE_PRODUCTS_DETAILS_FAIL:
      return {
        ...state,
        result: action.error.response.data,
        type: "error",
        loading: false
      }

    case ActionTypes.POSSIBLE_EXPIRATION_DATES:
      return { ...state, loading: true, type: "" }

    case ActionTypes.POSSIBLE_EXPIRATION_DATES_SUCCESS:
      dates = normalizeDates(action.payload)
      return { ...state, dates, loading: false }

    case ActionTypes.POSSIBLE_EXPIRATION_DATES_FAIL:
      return {
        ...state,
        loading: false,
        type: "error",
        result: action.error.response.data
      }

    case ActionTypes.CANCELLATION:
      return { ...state, result: action.payload, loading: true, type: "" }

    case ActionTypes.CANCELLATION_SUCCESS:
      returnData = {
        ...state,
        result: action.payload,
        type: "success",
        loading: false
      }

      messageKey = _get(action, "payload.data.messageKey")
      protocol = _get(action, "payload.protocolNumber")
      protocolNumberData = _get(action, "payload.data.protocolNumber")
      protocolNumberAlreadyExists = _get(
        action,
        "payload.data.resultMessageParams",
        []
      )
      resultMessage = _get(action, "payload.data.resultMessage")

      if (protocol && protocol !== "") {
        returnData.result.protocolNumber = protocol
      } else if (protocolNumberData && protocolNumberData !== "") {
        returnData.result.protocolNumber = protocolNumberData
      } else if (
        protocolNumberAlreadyExists &&
        protocolNumberAlreadyExists.length > 0
      ) {
        returnData.result.protocolNumber = protocolNumberAlreadyExists[0]
        returnData.result.resultMessage = resultMessage
      }

      if (
        !returnData.result.protocolNumber ||
        returnData.result.protocolNumber === ""
      ) {
        returnData.type = "error"
        returnData.error = true
      }

      if (messageKey && messageKey === "request.cancel.already.exists") {
        returnData.type = "progress"
        returnData.error = true
      }

      return returnData

    case ActionTypes.CANCELLATION_FAIL:
      return {
        ...state,
        result: action.payload,
        type: "error",
        loading: false
      }

    case ActionTypes.CHANGE_EXPIRATION_DATE:
      return { ...state, loading: true, type: "" }

    case ActionTypes.CHANGE_EXPIRATION_DATE_SUCCESS:
      return { ...state, loading: false, type: "success", result: action }

    case ActionTypes.CHANGE_EXPIRATION_DATE_FAIL:
      return {
        ...state,
        loading: false,
        type: "error",
        result: action.error.response.data
      }

    case ActionTypes.SET_MODAL:
      return { ...state, type: "" }

    case ActionTypes.SELECT_BILL:
      return { ...state, type: "", result: "", dates: null }

    case ActionTypes.CAN_CANCEL:
      return { ...state, loading: true }

    case ActionTypes.CAN_CANCEL_SUCCESS:
      return { ...state, loading: false, resultCanCancel: action.payload.data }

    case ActionTypes.CAN_CANCEL_FAIL:
      return {
        ...state,
        loading: false,
        resultCanCancel: action.error.response.data
      }

    case ActionTypes.SAVE_DEBIT:
      return { ...state, loading: true }

    case ActionTypes.SAVE_DEBIT_SUCCESS:
      return { ...state, loading: false }

    case ActionTypes.SAVE_DEBIT_FAIL:
      return { ...state, loading: false }

    case ActionTypes.CHANGE_LOADER:
      return { ...state, loading: action }

    case ActionTypes.ALL_SAVE_MORE_DEBITS:
      return { ...state, loading: false }

    case ActionTypes.GET_BANK_DATA:
      return { ...state, loading: true }

    case ActionTypes.GET_BANK_DATA_SUCCESS:
      return { ...state, loading: false }

    case ActionTypes.GET_BANK_DATA_FAIL:
      return { ...state, loading: false }

    default:
      return state
  }
}

const DEBIT_INITIAL_STATE = {
  banks: [],
  bankData: null,
  error: false,
  result: null,
  onlyBill: true,
  errorGet: false,
  lastTryTypeDebit: ""
}

export function debit(state = DEBIT_INITIAL_STATE, action) {
  let banksNew
  switch (action.type) {
    case ActionTypes.GET_BANKS:
      return { ...state, loading: true }

    case ActionTypes.GET_BANKS_SUCCESS:
      banksNew = normalizeBanks(action.payload.data)
      return { ...state, banks: banksNew, loading: false }

    case ActionTypes.GET_BANKS_FAIL:
      return { ...state, loading: false, errorGet: true }

    case ActionTypes.SAVE_DEBIT:
      return {
        ...state,
        error: false,
        result: null,
        lastTryTypeDebit: action.typeDebit
      }

    case ActionTypes.SAVE_DEBIT_SUCCESS:
      return { ...state, error: false, result: action.payload.data }

    case ActionTypes.SAVE_DEBIT_FAIL:
      return { ...state, error: true, result: action.error.response.data }

    case ActionTypes.DELETE_DEBIT:
      return {
        ...state,
        error: false,
        result: null,
        lastTryTypeDebit: action.typeDebit
      }

    case ActionTypes.DELETE_DEBIT_SUCCESS:
      return { ...state, error: false, result: action.payload.data }

    case ActionTypes.DELETE_DEBIT_FAIL:
      return { ...state, error: true, result: action.error.response.data }

    case ActionTypes.ALL_SAVE_MORE_DEBITS_SUCCESS:
      return { ...state }

    case ActionTypes.ALL_SAVE_MORE_DEBITS:
      return { ...state, onlyBill: false, result: action.payload }

    case ActionTypes.ALL_SAVE_MORE_DEBITS_FAIL:
      return { ...state, onlyBill: false }

    case ActionTypes.SET_DEBIT:
      return {
        ...state,
        error: false,
        result: null,
        bankData: null,
        errorGet: false,
        onlyBill: true
      }

    case ActionTypes.GET_BANK_DATA:
      return { ...state, loading: true }

    case ActionTypes.GET_BANK_DATA_SUCCESS:
      return { ...state, bankData: action.payload, loading: false }

    case ActionTypes.GET_BANK_DATA_FAIL:
      return {
        ...state,
        bankData: action.payload,
        loading: false,
        errorGet: true
      }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...DEBIT_INITIAL_STATE }

    default:
      return state
  }
}

const normalizeBanks = (payload) =>
  map((item) => ({ label: item.name, value: item.code }), payload)

function normalizeDates(data) {
  const dates = []

  data.map((item) => {
    const obj = {
      label: item,
      value: item
    }

    return dates.push(obj)
  })

  return dates
}

const TRAFFIC_INITIAL_STATE = {
  traffic: null,
  errors: false,
  loading: false
}

export function traffic(state = TRAFFIC_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_TRAFFIC_SUMMARY:
      return { ...state, loading: true }

    case ActionTypes.GET_TRAFFIC_SUMMARY_SUCCESS:
      return {
        ...state,
        errors: false,
        traffic: action.payload.data.resultData,
        loading: false
      }

    case ActionTypes.GET_TRAFFIC_SUMMARY_FAIL:
      return { ...state, errors: true, loading: false }

    default:
      return state
  }
}

const TRAFFIC_DETAILS_INITIAL_STATE = {
  data: null,
  errors: false
}

export function trafficDetails(state = TRAFFIC_DETAILS_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_TRAFFIC_DETAILS:
      return { ...state, loading: true }

    case ActionTypes.GET_TRAFFIC_DETAILS_SUCCESS:
      return {
        ...state,
        errors: false,
        data: action.payload.data,
        loading: false
      }

    case ActionTypes.GET_TRAFFIC_DETAILS_FAIL:
      return { ...state, errors: true, loading: false }

    default:
      return state
  }
}

const TRAFFIC_MAIL_INITIAL_STATE = {
  data: null,
  loading: false,
  errors: false
}

export function trafficMail(state = TRAFFIC_MAIL_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.SEND_TRAFFIC_EMAIL:
      return { ...state, loading: true }

    case ActionTypes.SEND_TRAFFIC_EMAIL_SUCCESS:
      return {
        ...state,
        errors: false,
        loading: false,
        data: action.payload.data
      }

    case ActionTypes.SEND_TRAFFIC_EMAIL_FAIL:
      return { ...state, errors: true, loading: false, data: null }

    default:
      return state
  }
}

export const DOWNLOAD_TRAFFIC_INITIAL_STATE = {
  data: null,
  loading: false,
  errors: false
}

export function downloadTraffic(
  state = DOWNLOAD_TRAFFIC_INITIAL_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.DOWNLOAD_TRAFFIC_DETAILS:
      return { ...state, loading: true }

    case ActionTypes.DOWNLOAD_TRAFFIC_DETAILS_SUCCESS:
      return {
        ...state,
        errors: false,
        loading: false,
        data: action.payload.data
      }

    case ActionTypes.DOWNLOAD_TRAFFIC_DETAILS_FAIL:
      return { ...state, errors: true, loading: false, data: null }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/billing/reducer.js